import axios from "axios";

export const getSessionToken = function() {
    let params = new URL(document.location.href).searchParams;
    return params.get("token") ? params.get("token") : params.get("sessionToken"); 
};

const URL_BASE = document.location.origin;
export const URL_SETTINGS = URL_BASE + "/monday/general/v1/settings";
export const URL_QUERY_SESSION_TOKEN = "?token=" + getSessionToken();

export const getSettings = async function(app) {
    const response = await axios({
        method: "post",
        url: URL_SETTINGS + URL_QUERY_SESSION_TOKEN,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        data: {
            app: app
        }
    });

    return response.data;
}

export const saveSettings = async function(app, settings) {
    const response = await axios({
        method: "put",
        url: URL_SETTINGS + URL_QUERY_SESSION_TOKEN,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        data: {
            app: app,
            settings: settings
        }
    });

    return response.data;
}
